import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useCurrentUser } from "hooks/useCurrentUser";

function TokenAvailableGuard({ children, ...rest }) {
  const { userToken } = useCurrentUser();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        userToken ? (
          <Redirect
            to={{
              pathname: "/home",
              state: { from: location },
            }}
          />
        ) : (
          children
        )
      }
    />
  );
}

export default TokenAvailableGuard;
